import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <h2>
              Unreal <span>Game Development</span> Services We Provide
            </h2>
            <p>
              Partner with an Unreal game development company that delivers
              high-performance, visually stunning, and technically advanced
              games. From photorealistic environments to complex gameplay
              mechanics, our Unreal Engine game development services ensure your
              project meets industry standards and exceeds player expectations
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start with a Free Call
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Full-Cycle Unreal Game Development</h4>
                  <p>
                    Our full-cycle Unreal game development services cover every
                    phase from concept to launch. We specialize in creating
                    intricate gameplay systems, optimizing performance, and
                    ensuring seamless integration across all platforms,
                    guaranteeing a polished final product that meets the highest
                    industry benchmarks.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>AR/VR/MR-Based Development</h4>
                  <p>
                    We craft immersive AR, VR, and MR experiences using Unreal
                    Engine's cutting-edge technology. Our services include
                    precise environment mapping, interaction design, and
                    performance optimization to create realistic, engaging
                    virtual experiences that align with your business
                    objectives.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Game Porting to Unreal Engine</h4>
                  <p>
                    Optimize your existing game by porting it to Unreal Engine.
                    We handle everything from asset conversion to engine
                    adaptation, ensuring a seamless transition. Our porting
                    services enhance graphics, improve performance, and enable
                    new features while maintaining the original game’s essence.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Art & Animation</h4>
                  <p>
                    Our art and animation team specializes in creating
                    high-fidelity visual assets. We focus on character modeling,
                    environmental design, and motion capture integration,
                    ensuring that every visual element enhances the overall
                    gameplay experience and meets the latest industry standards.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Porting UE4 to UE5 & Updating UE Version</h4>
                  <p>
                    Upgrade your game’s capabilities by porting it from Unreal
                    Engine 4 to 5. We ensure seamless transitions, leveraging
                    the new engine’s features like Nanite and Lumen for improved
                    visual fidelity and performance while maintaining the
                    original game’s integrity.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Game Testing</h4>
                  <p>
                    We offer comprehensive game testing services to identify and
                    fix performance bottlenecks, bugs, and gameplay issues. Our
                    testing process ensures your game is optimized for all
                    platforms, delivering a smooth, error-free player experience
                    that meets industry standards.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
